import axios from 'axios';

// 글로벌 axios에는 JWT 인증 인터셉터(helpers/request.js)가 설치되어 있어
// 비즈니스 API가 아닌 graylog로 토큰이 전송되지 않도록 인터셉터 없는 전용 인스턴스 사용
const graylogClient = axios.create();

const graylog = ({url="https://graylog.mealc.co.kr/front/", method="post", data, config}) => {


  const header = {
    "Content-Type" : "application/json"
  }

  return graylogClient({

    method
    , url
    , data
    , responseType : "json"
    , headers : header
    , ...config

  })


}

export default graylog;
